export const configs = {
  API_URL: import.meta.env.VITE_API_URL,
  LOCAL_TOKEN: import.meta.env.VITE_LOCAL_TOKEN,
}
